import { post, get } from "./api";

export const fetchJournalEntries = (customerId, params = {}, signal) => {
  return get(`/api/v2/customers/${customerId}/journalentries/`, params, signal);
};

export const removeTransactionJournalEntries = (
  customer_id,
  transaction_ids
) => {
  return post("/api/v2/remove_transaction_journal_entries/", {
    customer_id,
    transaction_ids,
  });
};
